/**
 * dir-w | backOffice
 * Retrieve token string, expired date and validateToken.
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { Configuration } from '../config/configuration';

@Injectable({ providedIn: 'root' })
export class TokenService {
  constructor() {}

  /**
   * get token from local storage
   * @returns string
   */
  static token(): string {
    const jsonData: any = LocalStorageService.get(Configuration.Profile);
    return jsonData['_token'];
  }

  /**
   * get token expiredDate
   * @returns string
   */
  static expiredDate(): string {
    const jsonData: any = LocalStorageService.get(Configuration.Profile);
    return jsonData['_tokenExpiredDate'];
  }
}
